import React from 'react';
import Tab from 'react-bootstrap/Tab';

import ContainerTabs from '../../../components/TabsContainer/TabsContainer';
import { DEFAULT_PAGE } from '../../../constants/paginationDefaults';
import { JobFilterProvider } from '../../../contexts/JobFilterProvider.js';
import OpeningsContainer from '../OpeningsContainer/OpeningsContainer';

const BrowseTabs = ({ tab, isPublic }) => (
  <ContainerTabs tab={tab} tabsKey="browse" isPublic={isPublic} queryParams={`page=${DEFAULT_PAGE}`}>
    <Tab eventKey="all">
      <JobFilterProvider>
        <OpeningsContainer isPublic={isPublic} tabkey="all" />
      </JobFilterProvider>
    </Tab>
  </ContainerTabs>
);

export default BrowseTabs;
